import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getPMDictDataApi,
    // 项目基础信息接口
    putProjectBaseApi,
    getWorkloadOBNApi,
    putWorkloadOBNApi,
    getWorkloadStreamerApi,
    putWorkloadStreamerApi,
    getGeometryOBNApi,
    putGeometryOBNApi,
    getGeometryStreamerApi,
    putGeometryStreamerApi,
    // Sreamer 接口
    postStreamerApi,
    // 甲方接口
    getClientApi,
    postClientApi,
    // 甲监接口
    getClientDetailsApi,
    postClientDetailsApi,
    postClientDetailsTableDataApi,
    putClientDetailsTableDataApi,
    getClientDetailsTableDataApi,
    deletClientDetailsTableDataApi,
    // 乙方接口
    getCrewApi,
    postCrewApi,
    // 施工队接口
    getCrewDetailsApi,
    postCrewDetailsApi,
    getCrewDetailsTableDataApi,
    postCrewDetailsTableDataApi,
    putCrewDetailsTableDataApi,
    deletCrewDetailsTableDataApi,
    // 录制接口
    getRecordingApi,
    postRecordingApi,
    // 接收接口
    getReceiverApi,
    postReceiverApi,
    postTerrainSettingApi,
    getTerrainSettingTableDataApi,
    deletTerrainSettingTableDataApi,
    postVpIntervalSettingApi,
    getVpIntervalSettingTableDataApi,
    deletVpIntervalSettingTableDataApi,
    deletReceiverTableDataApi,
    // 激发接口
    // getSourceApi,
    // postSourceApi,
    // getSourceTypeDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    pmDictData: null, // 字典
    dTictData: null, // 生产计划 字典
    eQDictData: null, // 设备计划 字典
    pTDictData: null, // 人员计划 字典
    mTDictData: null, // 材料计划 字典
    transferDictData: null, // 设备调拨 字典
    // 项目基础信息
    workloadOBNData: null,
    workloadStreamerData: null,
    geometryOBNData: null,
    geometryStreamerData: null,
    // 甲方数据
    clientData: null,
    // 甲监数据
    clientDetailsData: null,
    clientDetailsTableData: null,
    // 乙方数据
    crewData: null,
    // 施工队数据
    crewDetailsData: null,
    crewDetailsTableData: null,
    // 地形设置数据
    terrainSettingData: null,
    terrainSettingTableData: null,
    // 点距离设置数据
    PointDistanceSettingData: null,
    PointDistanceSettingTableData: null,
    // 接收数据
    receiverData: null,
    receiverTableData: null,
    // 录制数据
    recordingData: null,
    // 激发数据
    // sourceData: null,
    // sourceTypeData: null,
}

/* ====================================== 项目基础信息接口 ===================================================== */

/* 获取数据字典 */
export const getPMDictDataAction = createAsyncThunk('HomeSlice/getPMDictDataAction', async (dictType, thunkAPI) => {
    const projectTypeDict = getPMDictDataApi(dictType[0]) // 项目类型
    const acqAreaDict = getPMDictDataApi(dictType[1]) // 采集区域
    const sourceTypeDict = getPMDictDataApi(dictType[2]) // 暴露类型
    const receiverTypeDict = getPMDictDataApi(dictType[3]) // 接收类型
    const projectStaus = getPMDictDataApi(dictType[4]) // 项目状态
    const projectProductionType = getPMDictDataApi(dictType[5]) // 项目生产类型
    return Promise.all([projectTypeDict, acqAreaDict, sourceTypeDict, receiverTypeDict, projectStaus, projectProductionType])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 提交 projectBase 数据 */
export const putProjectBaseAction = createAsyncThunk(
    'ProjectConfigSlice/putProjectBaseAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await putProjectBaseApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 提交 streamer Rules 数据 */
export const postStreamerAction = createAsyncThunk(
    'ProjectConfigSlice/postProjectStreamerAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postStreamerApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取 Geometry OBN 数据 */
export const getGeometryOBNAction = createAsyncThunk(
    'ProjectConfigSlice/getGeometryOBNAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getGeometryOBNApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 Geometry OBN 数据 */
export const putGeometryOBNAction = createAsyncThunk(
    'ProjectConfigSlice/putGeometryOBNAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await putGeometryOBNApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 获取 Geometry Streamer 数据 */
export const getGeometryStreamerAction = createAsyncThunk(
    'ProjectConfigSlice/getGeometryStreamerAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getGeometryStreamerApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 Geometry Streamer 数据 */
export const putGeometryStreamerAction = createAsyncThunk(
    'ProjectConfigSlice/putGeometryStreamerAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await putGeometryStreamerApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取 Workload OBN 数据 */
export const getWorkloadOBNAction = createAsyncThunk(
    'ProjectConfigSlice/getWorkloadOBNAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getWorkloadOBNApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 Workload OBN 数据 */
export const putWorkloadOBNAction = createAsyncThunk(
    'ProjectConfigSlice/putWorkloadOBNAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await putWorkloadOBNApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 获取 Workload Streamer 数据 */
export const getWorkloadStreamerAction = createAsyncThunk(
    'ProjectConfigSlice/getWorkloadStreamerAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getWorkloadStreamerApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 Workload Streamer 数据 */
export const putWorkloadStreamerAction = createAsyncThunk(
    'ProjectConfigSlice/putWorkloadStreamerAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await putWorkloadStreamerApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典 生产计划 */
export const getPDDictDataAction = createAsyncThunk('HomeSlice/getPDDictDataAction', async (dictType, thunkAPI) => {
    const departmentDict = getPMDictDataApi(dictType[0]) // 班组
    const unitDict = getPMDictDataApi(dictType[1]) // 单位
    return Promise.all([departmentDict, unitDict])
        .then(dTictData => dTictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 获取数据字典 设备计划 */
export const getEQDictDataAction = createAsyncThunk('HomeSlice/getEQDictDataAction', async (dictType, thunkAPI) => {
    const departmentDict = getPMDictDataApi(dictType[0]) // 设备类型
    const unitDict = getPMDictDataApi(dictType[1]) // 使用班组
    const helicopterDict = getPMDictDataApi(dictType[2]) // 直升机类型
    const unitProductionplanDict = getPMDictDataApi(dictType[3]) // 设备单位
    return Promise.all([departmentDict, unitDict, helicopterDict, unitProductionplanDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 获取数据字典 人员计划 */
export const getPTDictDataAction = createAsyncThunk('HomeSlice/getPTDictDataAction', async (dictType, thunkAPI) => {
    const projectTypeDict = getPMDictDataApi(dictType[0]) // 项目类型
    const departmentDict = getPMDictDataApi(dictType[1]) // 班组
    return Promise.all([projectTypeDict, departmentDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 获取数据字典 材料计划 */
export const getMTDictDataAction = createAsyncThunk('HomeSlice/getMTDictDataAction', async (dictType, thunkAPI) => {
    const departmentDict = getPMDictDataApi(dictType[0]) // 班组
    return Promise.all([departmentDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
}
)
/* 获取数据字典 设备调拨 */
export const getTransferDictDataAction = createAsyncThunk('HomeSlice/getTransferDictDataAction', async (dictType, thunkAPI) => {
    const transferDict = getPMDictDataApi(dictType[0]) // 设备类型
    const transferStatusDict = getPMDictDataApi(dictType[1]) // 状态
    return Promise.all([transferDict, transferStatusDict])
        .then(dictData => dictData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* ====================================== 甲方信息接口 ===================================================== */
/* 获取 Client 数据 */
export const getClientAction = createAsyncThunk('ProjectConfigSlice/getClientAction', async (projectId, thunkAPI) => {
    try {
        const { data } = await getClientApi(projectId)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})
/* 提交 Client 数据 */
export const postClientAction = createAsyncThunk('ProjectConfigSlice/postClientAction', async (params, thunkAPI) => {
    try {
        const { data } = await postClientApi(params)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* ====================================== 甲监信息接口 ===================================================== */
/* 获取 ClientDetails 数据 */
export const getClientDetailsAction = createAsyncThunk(
    'ProjectConfigSlice/getClientDetailsAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getClientDetailsApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 ClientDetails 数据 */
export const postClientDetailsAction = createAsyncThunk(
    'ProjectConfigSlice/postClientDetailsAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postClientDetailsApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 ClientDetails 表格单条数据 */
export const postClientDetailsTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/postClientDetailsTableDataAction',
    async ({ params, modalAddNew }, thunkAPI) => {
        try {
            if (modalAddNew) {
                const { data } = await postClientDetailsTableDataApi(params)
                return data
            } else {
                const { data } = await putClientDetailsTableDataApi(params)
                return data
            }
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 获取 ClientDetails 表格数据 */
export const getClientDetailsTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/getClientDetailsTableDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getClientDetailsTableDataApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 删除 ClientDetails 表格单条数据 */
export const deletClientDetailsTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/deletClientDetailsTableDataAction',
    async (id, thunkAPI) => {
        try {
            const { data } = await deletClientDetailsTableDataApi(id)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 乙方信息接口 ===================================================== */
/* 获取 crew 数据 */
export const getCrewAction = createAsyncThunk('ProjectConfigSlice/getCrewAction', async (projectId, thunkAPI) => {
    try {
        const { data } = await getCrewApi(projectId)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})
/* 提交 Crew 数据 */
export const postCrewAction = createAsyncThunk('ProjectConfigSlice/postCrewAction', async (params, thunkAPI) => {
    try {
        const { data } = await postCrewApi(params)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* ====================================== 施工队信息接口 ===================================================== */
/* 获取 CrewDetails 数据 */
export const getCrewDetailsAction = createAsyncThunk(
    'ProjectConfigSlice/getCrewDetailsAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getCrewDetailsApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 CrewDetails 数据 */
export const postCrewDetailsAction = createAsyncThunk(
    'ProjectConfigSlice/postCrewDetailsAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postCrewDetailsApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 获取 CrewDetails 表格数据 */
export const getCrewDetailsTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/getCrewDetailsTableDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getCrewDetailsTableDataApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 CrewDetails 表格单条数据 */
export const postCrewDetailsTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/postCrewDetailsTableDataAction',
    async ({ params, modalAddNew }, thunkAPI) => {
        try {
            if (modalAddNew) {
                const { data } = await postCrewDetailsTableDataApi(params)
                return data
            } else {
                const { data } = await putCrewDetailsTableDataApi(params)
                return data
            }
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 删除 CrewDetails 表格单条数据 */
export const deletCrewDetailsTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/deletCrewDetailsTableDataAction',
    async (id, thunkAPI) => {
        try {
            const { data } = await deletCrewDetailsTableDataApi(id)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 地形设置接口 ===================================================== */
/* 获取 TerrainSetting 表格数据 */
export const getTerrainSettingTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/getTerrainSettingTableDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getTerrainSettingTableDataApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 TerrainSetting 表格单条数据 */
export const postTerrainSettingTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/postTerrainSettingTableDataAction',
    async ({ params }, thunkAPI) => {
        try {
            const { data } = await postTerrainSettingApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 删除 TerrainSetting 表格单条数据 */
export const deletTerrainSettingTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/deletTerrainSettingTableDataAction',
    async (id, thunkAPI) => {
        try {
            const { data } = await deletTerrainSettingTableDataApi(id)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 点距离设置接口 ===================================================== */
/* 获取 PointDistanceSetting 表格数据 */
export const getPointDistanceSettingTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/getPointDistanceSettingTableDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getVpIntervalSettingTableDataApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 PointDistanceSetting 表格单条数据 */
export const postPointDistanceSettingTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/postPointDistanceSettingTableDataAction',
    async ({ params }, thunkAPI) => {
        try {
            const { data } = await postVpIntervalSettingApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 删除 PointDistanceSetting 表格单条数据 */
export const deletePointDistanceSettingTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/deletPointDistanceSettingTableDataAction',
    async (id, thunkAPI) => {
        try {
            const { data } = await deletVpIntervalSettingTableDataApi(id)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 录制信息接口 ===================================================== */
/* 获取 Recording 数据 */
export const getRecordingAction = createAsyncThunk(
    'ProjectConfigSlice/getRecordingAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getRecordingApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 Recording 数据 */
export const postRecordingAction = createAsyncThunk(
    'ProjectConfigSlice/postRecordingAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postRecordingApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 接收信息接口 ===================================================== */
/* 获取 Recording 数据 */
export const getReceiverAction = createAsyncThunk(
    'ProjectConfigSlice/getReceiverAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getReceiverApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)
/* 提交 Recording 表格单条数据 */
export const postReceiverAction = createAsyncThunk(
    'ProjectConfigSlice/postReceiverAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await postReceiverApi(params)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 删除 Recording 表格单条数据 */
export const deleteReceiverTableDataAction = createAsyncThunk(
    'ProjectConfigSlice/deleteReceiverTableDataAction',
    async (id, thunkAPI) => {
        try {
            const { data } = await deletReceiverTableDataApi(id)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* ====================================== 激发信息接口 ===================================================== */
// /* 获取 Source 数据 */
// export const getSourceAction = createAsyncThunk('ProjectConfigSlice/getSourceAction', async (projectId, thunkAPI) => {
//     try {
//         const { data } = await getSourceApi(projectId)
//         return data
//     } catch (error) {
//         thunkAPI.dispatch(BoundarySlice.actions.addError(error))
//     }
// })
// /* 提交 Source 数据 */
// export const postSourceAction = createAsyncThunk('ProjectConfigSlice/postSourceAction', async (params, thunkAPI) => {
//     try {
//         const { data } = await postSourceApi(params)
//         return data
//     } catch (error) {
//         thunkAPI.dispatch(BoundarySlice.actions.addError(error))
//     }
// })

export const ProjectConfigSlice = createSlice({
    name: 'ProjectConfigSlice',
    initialState,
    reducers: {},
    extraReducers: {
        /* 获取项目字典 */
        [getPMDictDataAction.fulfilled.type]: (state, action) => {
            state.pmDictData = action.payload
        },
        /* 获取生产计划字典 */
        [getPDDictDataAction.fulfilled.type]: (state, action) => {
            state.dTictData = action.payload
        },
        /* 获取设备计划字典 */
        [getEQDictDataAction.fulfilled.type]: (state, action) => {
            state.eQDictData = action.payload
        },
        /* 获取人员计划字典 */
        [getPTDictDataAction.fulfilled.type]: (state, action) => {
            state.pTDictData = action.payload
        },
        /* 获取材料计划字典 */
        [getMTDictDataAction.fulfilled.type]: (state, action) => {
            state.mTDictData = action.payload
        },
        /* 获取设备调拨字典 */
        [getTransferDictDataAction.fulfilled.type]: (state, action) => {
            state.transferDictData = action.payload
        },
        /* ====================================== 项目基础信息处理 ===================================================== */
        /* 获取 Workload OBN 数据 */
        [getWorkloadOBNAction.fulfilled.type]: (state, action) => {
            state.workloadOBNData = action.payload
        },
        /* 获取 Workload Streamer 数据 */
        [getWorkloadStreamerAction.fulfilled.type]: (state, action) => {
            state.workloadStreamerData = action.payload
        },

        /* 获取 Geometry OBN 数据 */
        [getGeometryOBNAction.fulfilled.type]: (state, action) => {
            state.geometryOBNData = action.payload
        },
        /* 获取 Geometry Streamer 数据 */
        [getGeometryStreamerAction.fulfilled.type]: (state, action) => {
            state.geometryStreamerData = action.payload
        },

        /* ====================================== 甲方信息处理 ===================================================== */
        /* 获取 Client 数据 */
        [getClientAction.fulfilled.type]: (state, action) => {
            state.clientData = action.payload
        },

        /* ====================================== 甲监信息处理 ===================================================== */
        /* 获取 ClientDetails 数据 */
        [getClientDetailsAction.fulfilled.type]: (state, action) => {
            state.clientDetailsData = action.payload
        },
        /* 获取 ClientDetails 表格所有数据 */
        [getClientDetailsTableDataAction.fulfilled.type]: (state, action) => {
            state.clientDetailsTableData = action.payload
        },

        /* ====================================== 乙方信息处理 ===================================================== */
        /* 获取 Crew 数据 */
        [getCrewAction.fulfilled.type]: (state, action) => {
            state.crewData = action.payload
        },

        /* ====================================== 施工队信息处理 ===================================================== */
        /* 获取 CrewDetails 数据 */
        [getCrewDetailsAction.fulfilled.type]: (state, action) => {
            state.crewDetailsData = action.payload
        },
        /* 获取 CrewDetails 表格所有数据 */
        [getCrewDetailsTableDataAction.fulfilled.type]: (state, action) => {
            state.crewDetailsTableData = action.payload
        },

        /* ====================================== 地形设置处理 ===================================================== */
        /* 获取 TerrainSetting 表格所有数据 */
        [getTerrainSettingTableDataAction.fulfilled.type]: (state, action) => {
            state.terrainSettingTableData = action.payload
        },

        /* ====================================== 点距离设置处理 ===================================================== */
        /* 获取 TerrainSetting 表格所有数据 */
        [getPointDistanceSettingTableDataAction.fulfilled.type]: (state, action) => {
            state.PointDistanceSettingTableData = action.payload
        },

        /* ====================================== 录制信息处理 ===================================================== */
        /* 获取 Recording 数据 */
        [getRecordingAction.fulfilled.type]: (state, action) => {
            state.recordingData = action.payload
        },

        /* ====================================== 接收信息处理 ===================================================== */
        /* 获取 Receiver 数据 */
        [getReceiverAction.fulfilled.type]: (state, action) => {
            state.receiverTableData = action.payload
        },

        /* ====================================== 激发信息处理 ===================================================== */
        // /* 获取 Source 数据 */
        // [getSourceAction.fulfilled.type]: (state, action) => {
        //     state.sourceData = action.payload
        // },
    },
})
